export const EventsChart = {
    type: 'line',
    data: {
        labels: [],
        datasets: [{
            label: 'Events Total',
            data: [],
            borderWidth: 2,
            backgroundColor: '#37a0ea',
            borderColor: '#1f8fdd',
            pointBorderWidth: 2,
            pointRadius: 3.5,
            pointBackgroundColor: '#37a0ea',
            pointHoverBackgroundColor: '#37a0ea',
        }]
    },
    options: {
        responsive: true,
        legend: {
            display: false
        },
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                    let value = (tooltipItem.yLabel/1).toFixed(0).replace('.', ',')
                    return label+ ' : ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                }
             }
        },
        scales: {
            yAxes: [{
                gridLines: {
                    drawBorder: false,
                    color: '#f2f2f2',
                },
                ticks: {
                    stepSize: 1,
                    beginAtZero: false,
                    padding: 5,
                    callback: function (value) {
                        let val = (value/1).toFixed(0).replace('.', ',')
                        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                    }
                    
                }
            }],
            xAxes: [{
                gridLines: {
                    color: '#fbfbfb',
                    lineWidth: 2,
                    tickMarkLength: 25,
                }
            }]
        },
    }
}
export const AgentsChart = {
    type: 'line',
    data: {
        labels: [],
        datasets: [{
            label: 'Agents Total',
            data: [],
            borderWidth: 2,
            backgroundColor: '#37a0ea',
            borderColor: '#1f8fdd',
            pointBorderWidth: 2,
            pointRadius: 3.5,
            pointBackgroundColor: '#37a0ea',
            pointHoverBackgroundColor: '#37a0ea',
        }]
    },
    options: {
        responsive: true,
        legend: {
            display: false
        },
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                    let value = (tooltipItem.yLabel/1).toFixed(0).replace('.', ',')
                    return label+ ' : ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                }
             }
        },
        scales: {
            yAxes: [{
                gridLines: {
                    drawBorder: false,
                    color: '#f2f2f2',
                },
                ticks: {
                    stepSize: 1,
                    beginAtZero: false,
                    padding: 5,
                    callback: function (value) {
                        let val = (value/1).toFixed(0).replace('.', ',')
                        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                    }
                    
                }
            }],
            xAxes: [{
                gridLines: {
                    color: '#fbfbfb',
                    lineWidth: 2,
                    tickMarkLength: 25,
                }
            }]
        },
    }
}

export default {
    EventsChart,
    AgentsChart
}